import { render, staticRenderFns } from "./index.vue?vue&type=template&id=59d8b04e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Home: require('/Users/renwentao/Desktop/company-git/web/pagsmile-web/components/Home.vue').default})
